export const DISCOUNT_CODES = {
  // CURRENT: "web_friends"
  CURRENT: ""
};
